import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { CheckOutlined, CloseOutlined, InfoCircleTwoTone, SaveTwoTone } from '@ant-design/icons';
import {
  Switch,
  Row,
  Col,
  Typography,
  Select,
  DatePicker,
  Space,
  Segmented,
  Input,
  Popover,
  Button,
  Modal,
} from 'antd';
import { FaAngleDoubleLeft } from 'react-icons/fa';
import { Routes, Route, useNavigate } from 'react-router-dom';

import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from '../../config/api-connect';

import './style.css';
import { postData, getData } from '../../config/api-connect';

const { Text, Link } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const successModal = (message) => {
  Modal.success({
    title: message,
  });
};

const errorModal = (message) => {
  Modal.error({
    title: message,
  });
};

export default function AddBuddyData() {
  const [accountNo, setAccountNo] = useState('');
  const [ifsc, setIfsc] = useState('');
  const [fixedPay, setFixedPay] = useState('');
  const [receivedVenues, setReceivedVenues] = useState([]);
  const [selectedVenueId, setSelectedVenueId] = useState('');
  const [selectedBuddyId, setSelectedBuddyId] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getDetailsForExpenseAdding();
  }, []);

  const onChangeAccountNo = (e) => {
    setAccountNo(e.target.value);
  };

  const onChangeIfsc = (e) => {
    setIfsc(e.target.value);
  };

  const onChangeFixedPay = (e) => {
    setFixedPay(e.target.value);
  };

  const getDetailsForExpenseAdding = async () => {
    await getData('/finance/get_details_for_add_expense/')
      .then((response) => {
        setReceivedVenues(response.result);
      })
      .catch((error) => {
        errorModal(error.message);
      });
  };

  const saveBuddyData = async () => {
    await postData('/finance/create_buddy_data/', {
      buddy_id: selectedBuddyId,
      accountNo: accountNo,
      ifsc: ifsc,
      fixedPay,
      fixedPay,
    })
      .then((response) => {
        successModal(response.result);
      })
      .catch((error) => {
        errorModal(error.message);
      });
  };

  return (
    <div className="buddydata-main-container">
      <span></span>

      <div className="buddydata-center-container">
        <div className="buddydata-header">
          <span className="buddydata-back-link" onClick={() => navigate('/buddyinfo')}>
            <FaAngleDoubleLeft /> Back
          </span>
          <span>Add Buddy Data</span>
          <span> </span>
        </div>

        <div className="buddydata-body">
          <Row className="buddydata-row">
            <Col span={8}>
              <Text type="primary"> Choose Venue </Text>
            </Col>
            <Col span={8}>
              <Select
                allowClear
                showSearch
                className="buddydata-select"
                optionFilterProp="children"
                placeholder="start typing..."
                onChange={(input, option) => setSelectedVenueId(option.value)}
                value={selectedVenueId}
                filterOption={(input, option) => option.children.includes(input)}
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
              >
                {receivedVenues.map((item, index) => (
                  <Option value={item.id} key={index}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>

          <Row className="buddydata-row">
            <Col span={8}>
              <Text type="primary"> Buddy </Text>
              <Popover content="Buddy tagged to the selected venue">
                <InfoCircleTwoTone className="buddydata-info-icon" />
              </Popover>
            </Col>
            <Col span={14}>
              <Select
                allowClear
                showSearch
                className="buddydata-select"
                optionFilterProp="children"
                placeholder="start typing phone..."
                onChange={(input, option) => setSelectedBuddyId(option.value)}
                value={selectedBuddyId}
                filterOption={(input, option) => option.children.includes(input)}
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
              >
                {receivedVenues.map(
                  (item) =>
                    item.id == selectedVenueId &&
                    item.tagged_buddies.map((buddy, index) => (
                      <Option value={buddy.id} key={index}>
                        {buddy.name}
                      </Option>
                    )),
                )}
              </Select>
            </Col>
          </Row>

          <Row className="buddydata-row">
            <Col span={8}>
              <Text type="primary"> Account Number </Text>
            </Col>
            <Col span={8}>
              <Input
                placeholder=""
                className="buddydata-select"
                onChange={onChangeAccountNo}
                value={accountNo}
              />
            </Col>
          </Row>

          <Row className="buddydata-row">
            <Col span={8}>
              <Text type="primary"> IFSC Code </Text>
            </Col>
            <Col span={8}>
              <Input placeholder="" className="buddydata-select" onChange={onChangeIfsc} value={ifsc} />
            </Col>
          </Row>

          <Row className="buddydata-row">
            <Col span={8}>
              <Text type="primary"> Fixed Pay </Text>
            </Col>
            <Col span={8}>
              <Input
                placeholder=""
                className="buddydata-select"
                onChange={onChangeFixedPay}
                value={fixedPay}
              />
            </Col>
          </Row>

          <Row className="buddydata-button-row">
            <Button
              onClick={() => saveBuddyData()}
              type="primary"
              shape="round"
              icon={<SaveTwoTone />}
              className="buddydata-btn-wide"
            >
              {' '}
              Save{' '}
            </Button>
          </Row>
        </div>
      </div>

      <span></span>
    </div>
  );
}
